import { useTranslation } from 'react-i18next';
import { useCradSize } from '@/hooks/use-card-size';
import { useUserManagementHooks } from '@/manager';
import { VoiceIcon } from '@/components/assets/assets';
import { AudioTemplatesData } from '@/services/agent-user-get-audio-templates';
import { VoiceCard } from './voice-card';
import { AddVoiceModal } from './add-voice-modal';
import { TemplateEmpty2Icon } from './assets';

interface VoiceProps {
  voices: Audio[];
  loading: boolean;
  // 播客音频数据
  podcastVoices: AudioTemplatesData[];
}

/** 声音（播客才有） */
export const Voice = ({
  podcastVoices,
  voices,
  loading
}: VoiceProps) => {
  const { t } = useTranslation();
  const { deleteVoice } = useUserManagementHooks.usePodcastVoicesDelete();
  const { renameVoice } = useUserManagementHooks.usePodcastVoicesRename();
  const { saveVoices, loading: saveLoading } = useUserManagementHooks.usePodcastVoicesSave();

  const { ref, columns } = useCradSize({
    min: 180,
    max: 320,
    gap: 20,
    aspectRatio: 76 / 292,
    resizeObserverListen: true,
  });

  // 保存
  const handleSave = async (ids: string[]) => {
    await saveVoices(ids);
  }

  // 重命名
  const handleRename = async (voiceId: string, name: string) => {
    await renameVoice({ voiceId, name });
  }

  // 删除
  const handleDelete = async (voiceId: string) => {
    await deleteVoice(voiceId);
  }

  return (
    <div className="w-full h-full flex flex-col relative">
      <div className='flex items-center justify-between text-base font-medium text-[rgba(0,0,0,1)] mb-5'>
        <span>{t("agent_dashboard.user_detail.voice.title")}</span>
        <AddVoiceModal
          trigger={(
            <button className='h-10 flex items-center justify-center py-[10px] px-[14px] border border-[rgba(213,215,218,1)] hover:bg-gray-50  rounded-md shadow-sm transition-all'>
              <VoiceIcon className='size-5' />
              <span className='ml-1.5 text-sm text-[rgba(16,24,40,1)] font-semibold'>{t("agent_dashboard.user_detail.voice.add_voice")}</span>
            </button>
          )}
          voices={voices}
          onSave={handleSave}
          loading={saveLoading}
        />
      </div>
      <div>
        <div
          ref={ref}
          className="grid gap-5 w-full mb-5"
          style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
        >
          {loading && <Skeleton />}
          {!loading && podcastVoices.length > 0 ? (
            <>
              {/* <CreateAudioButton generateType="Minimax" /> */}
              {podcastVoices?.map((item, index) => (
                <VoiceCard
                  showDelete
                  key={`${item.id}_${index}`}
                  name={item.name}
                  audioUrl={item.sampleUrl}
                  id={item.id}
                  onRename={(name) => handleRename(item.id, name)}
                  onDelete={() => handleDelete(item.id)} />
              ))}
            </>
          ) : !loading && (
            <div className=' w-full h-full relative  flex flex-col justify-center items-center col-span-full mt-3 mb-16 gap-2'>
              <TemplateEmpty2Icon className='w-[198px]' />
              <span className='text-base text-[rgba(102,112,133,1)]'>{t("agent_dashboard.user_detail.voice.voice_empty")}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

// 骨架屏容器组件
function Skeleton() {
  return Array.from({ length: 20 }).map((_, index) => (
    <div key={index} className="w-full h-18 rounded-sm animate-pulse">
      <div className="w-full h-18 bg-gray-300 rounded-sm mb-4"></div>
    </div>
  ));
}